export const STREET_BLUE = '#3CB4B2'
export const UTB_BLUE = '#456CB3'
export const SUBHEAD_LIGHT_GRAY = '#707070'
export const HEADLINE_DARK_GRAY = '#283033'
